module.exports = __webpack_public_path__ + "img/inform.d2b8c652.svg";